import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'

export type OrderShortlistUserComment = {
  applicantId: number
  comment: string
  sentAt: string
  senderName: string | null
}

const useOrderShortlistUserComments = (orderId?: number) =>
  useQuery<OrderShortlistUserComment[]>({
    queryKey: ['orders', orderId, 'shortlist-user-comments'],
    queryFn: ({ signal }) =>
      fetchApiWithToken<OrderShortlistUserComment[]>({
        url: `/v1/orders/${orderId}/shortlist_user_comments`,
        signal
      }),
    enabled: !!orderId
  })

export const useApplicantShortlistUserComment = (
  orderId: number | undefined,
  applicantId: number
) =>
  useOrderShortlistUserComments(orderId).data?.find(
    (userComment) => userComment.applicantId === applicantId
  )
